module.exports = __webpack_public_path__ + "static/media/icon-next.9fd0b075.svg";